// extracted by mini-css-extract-plugin
export default {"header":"iFJVNB","placeholder":"E0mK8P"};